import { UPPERCASE_THEATER_IDS } from "../constants";

// Function to properly format movie titles
export function formatMovieTitle(title, theaterId) {
  // console.log('Formatting title:', { title, theaterId }); // Debug log
  if (!title) return "";
  
  // If it's from one of the theaters that returns all caps, convert to Title Case
  // But preserve acronyms like U.S.A., NYC, II, III, IV, D.C., etc.
  // KEEP IN SYNC with titleCaseForVenue in src/shared/displayTitle.js.
  if (UPPERCASE_THEATER_IDS.includes(theaterId)) {
    const letters = title.replace(/[^a-zA-Z]/g, '');
    if (!letters || letters !== letters.toUpperCase()) return title;
    const ROMAN_NUMERALS = new Set(['II', 'III', 'IV', 'VI', 'VII', 'VIII', 'IX', 'XI', 'XII']);
    const ACRONYMS = new Set(['NYC', 'USA', 'UK', 'TV', 'DC', 'IMAX']);
    const SMALL_WORDS = new Set(['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'in', 'of', 'on', 'or', 'the', 'to', 'with']);
    return title
      .split(' ')
      .map((word, i) => {
        // Preserve words with periods (U.S.A., D.C., N.Y.C.)
        if (/^[A-Z]\.([A-Z]\.)+[A-Z]?\.?$/.test(word)) return word;
        // Preserve roman numerals + known acronyms
        if (ROMAN_NUMERALS.has(word)) return word;
        if (ACRONYMS.has(word.replace(/[^a-zA-Z]/g, ''))) return word;
        const lower = word.toLowerCase();
        if (i > 0 && SMALL_WORDS.has(lower)) return lower;
        // Title case everything else (each slash segment: Roy Cohn/Jack Smith)
        return lower.split('/').map(seg => seg.charAt(0).toUpperCase() + seg.slice(1)).join('/');
      })
      .join(' ');
  }
  
  // For other theaters, return the title as is
  return title;
} 

// Helper function: Check if title contains non-ASCII characters (non-English)
// This detects Chinese, Japanese, Korean, Arabic, and other non-English languages
export function isNonEnglishTitle(title) {
  if (!title) return false;
  // Check if title contains any non-ASCII characters
  return /[^\x00-\x7F]/.test(title);
} 